export const SET_MODAL = 'SET_MODAL';
const CONSTANTS = {
  SET_TAG: 'SET_TAG',
  SET_TAG_FETCHING_STATUS: 'SET_TAG_FETCHING_STATUS',
  SET_TAG_VIDEOS: 'SET_TAG_VIDEOS',
  SET_TAG_CONTENTS: 'SET_TAG_CONTENTS',
  SET_TAG_CONTENTS_FETCHING_STATUS: 'SET_TAG_CONTENTS_FETCHING_STATUS',
  SET_TAG_ENTITIES_FETCHING_STATUS: 'SET_TAG_ENTITIES_FETCHING_STATUS'
};
export default CONSTANTS;
export const BANKS_CLEAR = 'BANKS_CLEAR';
export const BANKS_SET_ORGANIZATION = 'BANKS_SET_ORGANIZATION';
export const BANKS_SET_ORGANIZATION_FETCHING_STATUS = 'BANKS_SET_ORGANIZATION_FETCHING_STATUS';
export const BANKS_SET_ARTICLES = 'BANKS_SET_ARTICLES';
export const BANKS_SET_ARTICLES_FETCHING_STATUS = 'BANKS_SET_ARTICLES_FETCHING_STATUS';
export const BANKS_SET_ARTICLE = 'BANKS_SET_ARTICLE';
export const BANKS_SET_ARTICLE_FETCHING_STATUS = 'BANKS_SET_ARTICLE_FETCHING_STATUS';
export const BANKS_SET_QUESTIONS = 'BANKS_SET_QUESTIONS';
export const BANKS_SET_QUESTIONS_FETCHING_STATUS = 'BANKS_SET_QUESTIONS_FETCHING_STATUS';
export const BANKS_SET_TAGS = 'BANKS_SET_TAGS';
export const BANKS_SET_TAGS_FETCHING_STATUS = 'BANKS_SET_TAGS_FETCHING_STATUS';
export const BANKS_SET_PRODUCTS = 'BANKS_SET_PRODUCTS';
export const BANKS_SET_PRODUCTS_FETCHING_STATUS = 'BANKS_SET_PRODUCTS_FETCHING_STATUS';
export const BANKS_SET_MANAGEMENT_COMPANIES = 'BANKS_SET_MANAGEMENT_COMPANIES';
export const BANKS_SET_MANAGEMENT_COMPANIES_FETCHING_STATUS = 'BANKS_SET_MANAGEMENT_COMPANIES_FETCHING_STATUS';